import React, { useState }  from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/esm/Container';
import Card from 'react-bootstrap/Card';
import imgSrcMAC from './img/LOGOTIPO_HOSPITALES_MAC_1.png';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import axios from "axios";
import { Alert } from 'react-bootstrap';

const LoginForm = ({iniciarSesionParam, email, setEmail, password, setPassword, showModal, setShowModal, apiUrl, idUserSelected}) => {
  const [passwordNuevoSelected, setPasswordNuevoSelected] = useState('');
  const [passwordRepiteSelected, setPasswordRepiteSelected] = useState('');

  const handleCloseModal = ()=> {
    setShowModal(false)
  }

  const enterKey = (key) => {
    if(key === 'Enter') {
      iniciarSesionParam()
    }
  }

  const actualizaPassword = () => {
    // Validación de contraseña
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,16}$/;
    if (!regex.test(passwordNuevoSelected)) {
      alert('La contraseña no cumple con los requisitos');
      return;
    }
    if(passwordNuevoSelected!==passwordRepiteSelected){
      alert('Las contraseñas son diferentes, intenta de nuevo por favor.');
      return;
    }
    axios.post(`${apiUrl}/usuario/actualizaPassword?token=${sessionStorage.getItem('token')}`, 
      {
        IDUSUARIO: idUserSelected,
        PASSWORD: passwordNuevoSelected,
        USUARIOMODIFICACION: idUserSelected,
      })
      .then((objResponse)=>{
        setPassword("");
        setPasswordNuevoSelected("")
        setPasswordRepiteSelected("")
        handleCloseModal();
      })
      .catch((error)=>{
        alert('hubo un error en la actualización del usuario: ' + error.response.data)
      })
  }

  return (
    <div>
        {/* 
          Modal actualiza password
        */}
        <Modal show={showModal} onHide={handleCloseModal} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>
                Actualizar password
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Table striped hover responsive size="sm" style={{fontSize: '1em'}}>
                  <tbody>
                      <tr>
                        <td>Escribe contraseña</td>
                        <td>
                          <Form.Control type="password" value={passwordNuevoSelected} onChange={(event)=>{ setPasswordNuevoSelected(event.target.value) }}></Form.Control>
                        </td>
                      </tr>
                      <tr>
                        <td>Repite contraseña</td>
                        <td>
                          <Form.Control type="password" value={passwordRepiteSelected} onChange={(event)=>{ setPasswordRepiteSelected(event.target.value) }}></Form.Control>
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td>
                          <h6>Requisitos contraseña</h6>
                          <ul>
                            <li>Mayúsculas y minúsculas</li>
                            <li>Al menos 1 caracter especial</li>
                            <li>Al menos 1 número</li>
                            <li>Mínimo 8 - Máximo 16 caracteres</li>
                          </ul>
                        </td>
                        <td></td>
                      </tr>
                  </tbody>
              </Table>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModal}>
                  Close
                </Button>
                <Button 
                  variant="success" 
                  onClick={actualizaPassword}
                >
                  Actualizar
                </Button>
            </Modal.Footer>
        </Modal>
        {/* 
          Contenido principal
        */}
        <Container style={{marginTop: '1em'}}>
        <Row>
          <Col></Col>
          <Col>
            <Card style={{ width: '18rem' }} >
              <Card.Header as="h5"><Card.Img variant="top" src={imgSrcMAC} /></Card.Header>
              <Card.Body>
                <Form>
                  <Container>
                    <Row className='mb-3'>
                      <Form.Label>Correo: </Form.Label>
                      <Form.Control required 
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)} 
                        onKeyUp={(event)=>{ enterKey(event.key) }}
                        placeholder='Correo'></Form.Control>
                    </Row>
                    <Row>
                      <Form.Label>Password: </Form.Label>
                      <Form.Control required 
                        type='password'
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        onKeyUp={(event)=>{ enterKey(event.key) }}
                        placeholder="Contraseña" ></Form.Control>
                    </Row>
                  </Container>
                </Form>
                <br/>
                <Button onClick={()=>{iniciarSesionParam()}} style={{marginTop: '1em'}}>Iniciar sesión</Button>
              </Card.Body>
            </Card>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </div>
  )
}

export default LoginForm;